/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { UserDiagnosisResultV2KarteFragmentDoc } from '../UserDiagnosisResultV2/UserDiagnosisResultV2.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type DiagnosisType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type HouseholdStructureType =
  /** 子なし夫婦世帯 */
  | 'COUPLE_WITHOUT_CHILDREN'
  /** 子あり夫婦世帯 */
  | 'COUPLE_WITH_CHILDREN'
  /** 単身世帯 */
  | 'ONE_PERSON'
  /** 定年後世帯 */
  | 'RETIRED'
  /** ひとり親世帯 */
  | 'SINGLE_WITH_CHILDREN'
  | 'UNSPECIFIED';

export type RankInCluster =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'UNSPECIFIED';

export type DiagnosisResultModalKarteQueryVariables = Exact<{
  id: string | number;
}>;


export type DiagnosisResultModalKarteQuery = { karte: { user: { channel: Types.Channel, nickname: string }, diagnosis: { uuid: string, annualIncome: number, savingMonth: number, saving: number, investment: number, diagnosisSummary: { __typename: 'DiagnosisSummary', type: Types.DiagnosisType, assetsRank: Types.RankInCluster, householdAnnualIncomeRank: Types.RankInCluster, monthlySavingRank: Types.RankInCluster, cluster: { householdStructure: Types.HouseholdStructureType, residentialArea: { country: string, prefecture: string | null, city: string | null, town: string | null }, statistics: { meanAge: number, meanNumberOfChildren: number, investmentRatio: number, meanHouseholdAnnualIncome: number, meanMonthlySaving: number, meanAssets: number } } } | null, aiMatchScore: { __typename: 'AiMatchScore', lifePlanningMatchingScore: number, onetimeSaleMatchingScore: number, householdImprovementMatchingScore: number, sellingHomeMatchingScore: number, realEstateInvestmentMatchingScore: number, jobChangeMatchingScore: number } | null, partner: { annualIncome: number } | null } } };


export const DiagnosisResultModalKarteDocument = gql`
    query DiagnosisResultModalKarte($id: ID!) {
  karte(id: $id) {
    user {
      channel
    }
    diagnosis {
      diagnosisSummary {
        __typename
      }
      aiMatchScore {
        __typename
      }
    }
    ...UserDiagnosisResultV2Karte
  }
}
    ${UserDiagnosisResultV2KarteFragmentDoc}`;

/**
 * __useDiagnosisResultModalKarteQuery__
 *
 * To run a query within a Vue component, call `useDiagnosisResultModalKarteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosisResultModalKarteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiagnosisResultModalKarteQuery({
 *   id: // value for 'id'
 * });
 */
export function useDiagnosisResultModalKarteQuery(variables: DiagnosisResultModalKarteQueryVariables | VueCompositionApi.Ref<DiagnosisResultModalKarteQueryVariables> | ReactiveFunction<DiagnosisResultModalKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables>(DiagnosisResultModalKarteDocument, variables, options);
}
export function useDiagnosisResultModalKarteLazyQuery(variables?: DiagnosisResultModalKarteQueryVariables | VueCompositionApi.Ref<DiagnosisResultModalKarteQueryVariables> | ReactiveFunction<DiagnosisResultModalKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables>(DiagnosisResultModalKarteDocument, variables, options);
}
export type DiagnosisResultModalKarteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DiagnosisResultModalKarteQuery, DiagnosisResultModalKarteQueryVariables>;